import request from '@/utils/request'

const api = {
  // 销售统计
  QueryMoney(data) {
    return request({
      url: 'admin/finance/queryMoney',
      method: 'post',
      data
    })
  },
  GetAllMoneyList(data) {
    return request({
      url: 'admin/finance/getAllMoney',
      method: 'post',
      data
    })
  },
  // 商品统计
  QueryProduct(data) {
    return request({
      url: 'admin/finance/queryProduct',
      method: 'post',
      data
    })
  },
  GetAllProductList(data) {
    return request({
      url: 'admin/finance/getAllProduct',
      method: 'post',
      data
    })
  },
  // 商品明细
  QueryProductDetail(data) {
    return request({
      url: 'admin/finance/queryProductDetail',
      method: 'post',
      data
    })
  },
  GetAllProductListDetail(data) {
    return request({
      url: 'admin/finance/getAllProductDetail',
      method: 'post',
      data
    })
  },
  // 订单分佣
  QueryOrder(data) {
    return request({
      url: 'admin/finance/QueryOrder',
      method: 'post',
      data
    })
  },
  // 导出分佣订单
  QueryOrderExport(data) {
    return request({
      url: 'admin/finance/QueryOrderExport',
      method: 'post',
      data
    })
  },
  getwechatTime(data) {
    return request({
      url: 'admin/finance/getwechatTime',
      method: 'post',
      data
    })
  },
  // 下载对账单
  QueryOrderDevide(data) {
    return request({
      url: 'admin/finance/getwechatOrder',
      method: 'post',
      data
    })
  },
  // 平台总销售额
  QueryPlatform(data) {
    return request({
      url: 'admin/finance/platformCount',
      method: 'post',
      data
    })
  },
  // 平台总销售额导出
  ExportPlatformList(data) {
    return request({
      url: 'admin/finance/exportPlatformCount',
      method: 'post',
      data
    })
  },
  // 公司订单统计
  QueryCompanyOrder(data) {
    return request({
      url: 'admin/finance/companyOrder',
      method: 'post',
      data
    })
  },
  // 团餐销售额
  QueryGroup(data) {
    return request({
      url: 'admin/finance/groupCount',
      method: 'post',
      data
    })
  },
  // 外卖销售额
  QueryOut(data) {
    return request({
      url: 'admin/finance/outCount',
      method: 'post',
      data
    })
  },
  // 外卖订单导出
  ExportOutList(data) {
    return request({
      url: 'admin/finance/exportPlatformCount',
      method: 'post',
      data
    })
  },
  // 团餐订单导出
  ExportGroupList(data) {
    return request({
      url: 'admin/finance/exportPlatformCount',
      method: 'post',
      data
    })
  },
  // 全部账单
  QueryBill(data) {
    return request({
      url: 'admin/finance/bill',
      method: 'post',
      data
    })
  },
  ExportBillList(data) {
    return request({
      url: 'admin/finance/exportBill',
      method: 'post',
      data
    })
  }
}
export default api
